import { useCallback, useEffect, useState } from "react";
import { Stack } from "@fluentui/react/lib/Stack";
import { TextField } from "@fluentui/react/lib/TextField";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { WithTranslator } from "Components/Generic/Translator";
import { isNullOrWhiteSpace } from "Utils/String";
import { IUserProps } from "./IUserProps";

export const User = WithTheme(
  WithTranslator((props: IUserProps): JSX.Element => {
    const {
      user,
      onChange,
      translator,
      disableAfterExport,
      theme: { spacing }
    } = props;
    const [currentUserName, setCurrentUsername] = useState<string>(user?.name ?? ``);
    const [currentDisplayName, setCurrentDisplayName] = useState<string>(user?.displayName ?? ``);

    useEffect(() => {
      if (isNullOrWhiteSpace(user?.name)) {
        setCurrentUsername(``);
      }

      if (isNullOrWhiteSpace(user?.displayName)) {
        setCurrentDisplayName(``);
      }
    }, [user?.name, user?.displayName]);

    const onUsernameChange = useCallback(
      (_: unknown, value: string) => {
        let currentDisplayNameChanged = false;
        if (currentDisplayName === currentUserName || isNullOrWhiteSpace(currentDisplayName)) {
          setCurrentDisplayName(value);
          currentDisplayNameChanged = true;
        }

        setCurrentUsername(value);
        onChange(value, currentDisplayNameChanged ? value : currentDisplayName);
      },
      [currentDisplayName, currentUserName, onChange]
    );

    const onDisplayNameChange = useCallback(
      (_: unknown, value: string) => {
        setCurrentDisplayName(value);
        onChange(currentUserName, value);
      },
      [currentUserName, onChange]
    );

    return (
      <Stack grow horizontal tokens={{ childrenGap: spacing.s2 }}>
        <Stack.Item grow>
          <TextField
            placeholder={translator.get(`storage.@users.name`, `Username`)}
            value={currentUserName}
            onChange={onUsernameChange}
            disabled={disableAfterExport}
          />
        </Stack.Item>
        <Stack.Item grow>
          <TextField
            placeholder={translator.get(`storage.@users.displayName`, `Display name`)}
            value={currentDisplayName}
            onChange={onDisplayNameChange}
            disabled={disableAfterExport}
          />
        </Stack.Item>
      </Stack>
    );
  })
);
